<template>
  <div id="dropdown-component">
    <div class="form-group">
      <label v-if="label !== ''" :for="name">
        {{ label }}
        <span v-if="mandatory" class="text-danger"> * </span>
      </label>
      <select
        :id="`${name}-${index || ''}`"
        :name="name"
        :value="modelValue"
        :placeholder="placeholder"
        class="form-select"
        :class="`form-select-${size} ${
          fieldState === false ? 'is-invalid' : ''
        }`"
        :disabled="isDisable"
        @change="$emit('changeEvent', name, index)"
        @input="$emit('update:modelValue', $event.target.value)"
      >
        <template v-for="option in options" :key="option.value">
          <option
            v-if="!option.value || option.value === 'null'"
            value=""
            :selected="true"
            :disabled="true"
          >
            {{ option.text }}
          </option>
          <option v-else :value="option.value" :selected="false">
            {{ option.text }}
          </option>
        </template>
      </select>
      <error-message-new
        v-if="!fieldState"
        :index="index"
        :errors="errors"
        :fieldName="name"
        :parent="parent"
      />
    </div>
  </div>
</template>

<script>
import { $hasField } from "@/helper/globalFunction.js";
import { handleFieldState } from "@/helper/fieldStateHandler";

export default {
  props: {
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    index: {
      type: Number,
      default: null,
    },
    modelValue: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
    size: {
      type: String,
      default: "sm",
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: String,
      default: null,
    },
    showError: {
      type: Boolean,
      default: true,
    },
    mandatory: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    logic: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      localValue: null,
    };
  },
  computed: {
    fieldState() {
      return (
        this.$hasField({
          name: this.name,
          errors: this.errors,
          index: this.index,
          parent: this.parent,
        }) && this.showError
      );
    },
  },
  methods: {
    $hasField,
    handleFieldState,
  },
};
</script>

<style scoped>
#dropdown-component .form-select {
  width: 100%; /* Adjust width as needed */
  max-width: none; /* Remove any max-width constraints */
  overflow: visible; /* Ensure overflow is visible */
  white-space: nowrap; /* Prevent text wrapping */
}
</style>
